import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetLeaderboardResponse } from './get-leaderboard-response';
import { getLeaderboardResponseSchema } from './get-leaderboard-response';

export async function getLeaderboardApi(
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetLeaderboardResponse>> {
  return getRequest<IGetLeaderboardResponse>({
    path: '/progress/leaderboard',
    schema: getLeaderboardResponseSchema,
    options,
  });
}
